import {twMerge} from "tailwind-merge";
import {JourneyProgressBar} from "./JourneyProgressBar";
import {JourneyProgressCardActions} from "./JourneyProgressCardActions";
import {JourneyProgressCardHeader} from "./JourneyProgressCardHeader";
import {JourneyProgressCardMeta} from "./JourneyProgressCardMeta";
import type {JourneyProgressCardProps} from "./types";

export function JourneyProgressCard({
    title,
    status,
    createdAtLabel,
    stages,
    ouName,
    actions,
    onDisposeClick,
    isSelected = false,
    className,
}: JourneyProgressCardProps) {
    const isActive = status === "active";
    const visibleActions = isActive === true ? actions : [];
    const hasActions = visibleActions.length > 0;
    const isSelectedState = isSelected === true;

    return (
        <div
            className={twMerge(
                "@container flex w-full min-w-0 flex-col overflow-hidden rounded-ds-border-radius border border-solid transition-colors",
                isSelectedState
                    ? "border-ds-border-selected bg-ds-background-selected"
                    : "border-ds-border bg-ds-surface hover:bg-ds-surface-hovered",
                className,
            )}
            data-selected={isSelectedState ? "true" : "false"}
        >
            <div
                className={twMerge(
                    "flex w-full min-w-0 flex-col gap-y-ds-space-150 p-ds-space-200",
                    hasActions === true ? "pb-ds-space-150" : null,
                )}
            >
                <div className="flex w-full min-w-0 flex-col gap-y-ds-space-100">
                    <JourneyProgressCardHeader
                        title={title}
                        status={status}
                        ouName={ouName}
                    />
                    <JourneyProgressCardMeta
                        createdAtLabel={createdAtLabel}
                        onDisposeClick={onDisposeClick}
                    />
                </div>
                {stages.length > 0 ? <JourneyProgressBar stages={stages} /> : null}
            </div>
            {hasActions === true ? <JourneyProgressCardActions actions={visibleActions} /> : null}
        </div>
    );
}
